import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const centsInput = (value) => {
  const number = Number(String(value).trim().replace(",", "."));
  if (!Number.isFinite(number) || number <= 0) throw new Error("Preis muss größer als 0 sein");
  return Math.round(number * 100);
};

export const publishedVersion = (versions) =>
  [...(versions || [])]
    .filter((item) => item.status === "published")
    .sort((a, b) => (b.version_sequence || 0) - (a.version_sequence || 0))[0] || null;

export const latestEditableDraft = (versions) =>
  [...(versions || [])]
    .filter((item) => item.status === "draft")
    .sort((a, b) => new Date(b.updated_at || b.created_at || 0) - new Date(a.updated_at || a.created_at || 0))[0] || null;

export const contractSettingsApi = {
  getTemplates: () => axios.get(`${API}/admin/legal-templates`),
  createTemplate: (payload) => axios.post(`${API}/admin/legal-templates`, payload),
  updateTemplate: (id, payload) => axios.patch(`${API}/admin/legal-templates/${id}`, payload),
  publishTemplate: (id) => axios.post(`${API}/admin/legal-templates/${id}/publish`),
  getTariffs: () => axios.get(`${API}/admin/contract-settings/tariffs`),
  saveTariffs: (contractTariffs) =>
    axios.put(`${API}/admin/contract-settings/tariffs`, { contract_tariffs: contractTariffs }),
};

